(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sarjan-product-card"] && !Shopify.designMode) return;
  try {
    window.sarjanCartAdd = window.sarjanCartAdd || function (formDataOrId, qty) {
    const drawer = document.querySelector('cart-drawer');
    let fd;
    if (formDataOrId instanceof FormData) {
      fd = formDataOrId;
    } else {
      fd = new FormData();
      fd.append('id', formDataOrId);
      fd.append('quantity', qty || 1);
    }
    const routes = window.sarjanRoutes || {};
    const useDrawer = drawer && typeof drawer.renderContents === 'function';
    if (useDrawer) {
      drawer.getSectionsToRender = () => [{ id: 'cart-drawer', selector: '#CartDrawer' }];
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
    }
    return fetch(routes.cartAdd || '/cart/add', { method: 'POST', body: fd, headers: { Accept: 'application/javascript' } })
      .then((r) => r.json())
      .then((data) => {
        if (data.status && data.message) throw new Error(data.description || data.message);
        if (useDrawer) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        }
        return fetch((routes.cart || '/cart') + '.js').then((r) => r.json());
      })
      .then((cart) => {
        const icon = document.getElementById('cart-icon-bubble');
        if (icon && cart) {
          let badge = icon.querySelector('.sarjan-header__cart-count');
          if (!badge && cart.item_count > 0) {
            badge = document.createElement('span');
            badge.className = 'sarjan-header__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            icon.appendChild(badge);
          }
          if (badge) badge.textContent = cart.item_count;
        }
        return cart;
      });
  };

  if (!window.sarjanQuickaddBound) {
    window.sarjanQuickaddBound = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-sarjan-quickadd]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      btn.disabled = true;
      window
        .sarjanCartAdd(btn.dataset.sarjanQuickadd)
        .catch(() => { window.location.href = (window.sarjanRoutes || {}).cart || '/cart'; })
        .finally(() => { btn.disabled = false; });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
